const EVM_NETWORKS: Record<string, { chainId: string; name: string }> = {
  ethereum: { chainId: '0x1', name: 'Ethereum' },
  base: { chainId: '0x2105', name: 'Base' },
  arbitrum: { chainId: '0xa4b1', name: 'Arbitrum' },
  bnb: { chainId: '0x38', name: 'BNB Smart Chain' },
  optimism: { chainId: '0xa', name: 'Optimism' },
};

const connect = async (
  network: 'solana' | 'ethereum' | 'base' | 'arbitrum' | 'bnb' | 'optimism',
  setNetwork: React.Dispatch<React.SetStateAction<'solana' | 'ethereum' | 'base' | 'arbitrum' | 'bnb' | 'optimism' | null>>
): Promise<string[]> => {
  if (network === 'solana' && window.solana?.isPhantom) {
    try {
      const { publicKey } = await window.solana.connect();
      setNetwork('solana');
      return [`Solana Wallet connected successfully!`, `Public Key: ${publicKey.toString()}`];
    } catch {
      return ['Failed to connect to Solana wallet.'];
    }
  }

  if (window.ethereum?.isMetaMask && EVM_NETWORKS[network]) {
    try {
      const { chainId } = EVM_NETWORKS[network];

      // Attempt to switch to the correct chain
      await window.ethereum.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId }],
      });

      const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
      setNetwork(network);
      return [`${EVM_NETWORKS[network].name} Wallet connected successfully!`, `Address: ${accounts[0]}`];
    } catch (err: any) {
      if (err.code === 4902) {
        return [`Chain not added to MetaMask. Please add ${EVM_NETWORKS[network].name} manually.`];
      }
      return [`Failed to connect to ${EVM_NETWORKS[network].name} wallet.`];
    }
  }

  return ['Unsupported network. Use "solana", "ethereum", "base", "arbitrum", "bnb", or "optimism".'];
};

export default connect;
